"use client";

import { getStudentDetail } from "@/api";
import { isAdminUser } from "@/app/lib/isAdminUser";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function PublishBlogButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const user = await getStudentDetail();
        setShowButton(isAdminUser(user));
      } catch (error) {
        setShowButton(false);
      }
    };

    loadUser();
  }, []);

  if (!showButton) return null;

  return (
    <Link
      href="/blog/publish"
      className="px-5 py-2 rounded-md bg-primary text-white text-sm font-medium"
    >
      Publish a Blog
    </Link>
  );
}

